import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';
import { useStepper } from '@/features/v2/lib/stepper';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const REPAIR_DOCUMENTS_PROVIDED_TO_IC = {
  YES: 'yes',
  NO: 'no',
} as const;

export const REPAIR_DOCUMENTS_PROVIDED_TO_IC_NAME =
  'repair_documents_provided_to_ic';
export const RadioGroupRepairDocumentsProvidedToInsurance = ({
  name = REPAIR_DOCUMENTS_PROVIDED_TO_IC_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const { innerStep } = useStepper();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          // TODO: Maybe do it better
          value: innerStep >= 2 ? true : false,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy przekazywano do ubezpieczalni likwidującej szkodę faktury, rachunki lub inne dokumenty potwierdzające naprawę pojazdu, zakup części?'
            )}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-repair-documents-provided-to-ic"
            >
              <RadioItem
                value={REPAIR_DOCUMENTS_PROVIDED_TO_IC.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-repair-documents-provided-to-ic-yes"
              />
              <RadioItem
                value={REPAIR_DOCUMENTS_PROVIDED_TO_IC.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-repair-documents-provided-to-ic-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
